module.exports = __webpack_public_path__ + "static/media/portfolio2.7148bf34.jpg";